(function(){
  /* Highlight active bottom bar tab based on current URL */
  (function() {
    var path = window.location.pathname;
    var map = {
      'czx-bottom-home':     path === '/',
      'czx-bottom-wishlist': path.indexOf('/pages/wishlist') === 0,
      'czx-bottom-account':  path.indexOf('/account') === 0,
    };
    Object.keys(map).forEach(function(id) {
      var el = document.getElementById(id);
      if (el && map[id]) el.classList.add('active');
    });
  })();

  /* Desktop mega menus */
  var items = document.querySelectorAll('.crazxy-nav-item:has(.crazxy-mega)');
  var closeTimer = null;
  items.forEach(function(item){
    var btn  = item.querySelector('.crazxy-nav-btn');
    var mega = item.querySelector('.crazxy-mega');
    if (!btn || !mega) return;
    item.addEventListener('mouseenter', function(){
      clearTimeout(closeTimer);
      items.forEach(function(i){
        i.querySelector('.crazxy-nav-btn')?.classList.remove('active');
        i.querySelector('.crazxy-mega')?.classList.remove('open');
      });
      btn.classList.add('active');
      mega.classList.add('open');
    });
    item.addEventListener('mouseleave', function(){
      closeTimer = setTimeout(function(){ btn.classList.remove('active'); mega.classList.remove('open'); }, 120);
    });
    mega.addEventListener('mouseenter', function(){ clearTimeout(closeTimer); });
    mega.addEventListener('mouseleave', function(){
      closeTimer = setTimeout(function(){ btn.classList.remove('active'); mega.classList.remove('open'); }, 120);
    });
  });
  document.addEventListener('click', function(e){
    if (!e.target.closest('#crazxy-navbar')) {
      items.forEach(function(i){
        i.querySelector('.crazxy-nav-btn')?.classList.remove('active');
        i.querySelector('.crazxy-mega')?.classList.remove('open');
      });
    }
  });

  /* Mobile drawer */
  var hamburger = document.getElementById('crazxy-hamburger');
  var navClose  = document.getElementById('crazxy-nav-close');
  var overlay   = document.getElementById('crazxy-mobile-overlay');
  var drawer    = document.getElementById('crazxy-mobile-drawer');

  function openDrawer(){
    overlay.classList.add('open'); drawer.classList.add('open');
    drawer.setAttribute('aria-hidden','false');
    hamburger.setAttribute('aria-expanded','true');
    document.body.style.overflow='hidden';
    /* Highlight Menu tab, deactivate others */
    document.querySelectorAll('.czx-bottom-btn').forEach(function(b){ b.classList.remove('active'); });
    var menuBtn = document.getElementById('czx-bottom-menu');
    if (menuBtn) menuBtn.classList.add('active');
    /* Switch to X icon */
    var iconOpen  = document.getElementById('czx-menu-icon-open');
    var iconClose = document.getElementById('czx-menu-icon-close');
    var label     = document.getElementById('czx-menu-label');
    if (iconOpen)  iconOpen.style.display  = 'none';
    if (iconClose) iconClose.style.display = 'block';
    if (label)     label.textContent = 'Close';
  }
  function closeDrawer(navigateHome){
    overlay.classList.remove('open'); drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden','true');
    hamburger.setAttribute('aria-expanded','false');
    document.body.style.overflow='';
    /* Switch back to hamburger icon */
    var iconOpen  = document.getElementById('czx-menu-icon-open');
    var iconClose = document.getElementById('czx-menu-icon-close');
    var label     = document.getElementById('czx-menu-label');
    if (iconOpen)  iconOpen.style.display  = 'block';
    if (iconClose) iconClose.style.display = 'none';
    if (label)     label.textContent = 'Menu';
    /* Restore correct active tab based on URL */
    document.querySelectorAll('.czx-bottom-btn').forEach(function(b){ b.classList.remove('active'); });
    var path = window.location.pathname;
    var activeId = path === '/' ? 'czx-bottom-home'
                 : path.indexOf('/pages/wishlist') === 0 ? 'czx-bottom-wishlist'
                 : path.indexOf('/account') === 0 ? 'czx-bottom-account'
                 : null;
    if (activeId) { var el = document.getElementById(activeId); if (el) el.classList.add('active'); }
    /* Navigate to home if X button was clicked */
    if (navigateHome) window.location.href = '/';
  }
  window._czxDrawerOpen  = openDrawer;
  window._czxDrawerClose = closeDrawer;

  /* Bottom bar menu button: toggle open/close; X closes and goes home */
  var bottomMenu = document.getElementById('czx-bottom-menu');
  if (bottomMenu) {
    bottomMenu.addEventListener('click', function() {
      var isOpen = drawer.classList.contains('open');
      if (isOpen) { closeDrawer(false); }  /* X clicked → just close, stay on current page */
      else        { openDrawer(); }
    });
  }

  if(hamburger) hamburger.addEventListener('click', openDrawer);
  if(navClose)  navClose.addEventListener('click', closeDrawer);
  if(overlay)   overlay.addEventListener('click', function(){ closeDrawer(false); });

  /* Mobile accordion */
  document.querySelectorAll('.crazxy-mobile-toggle[data-target]').forEach(function(toggle){
    toggle.addEventListener('click', function(){
      var sub = document.getElementById(toggle.getAttribute('data-target'));
      var isOpen = sub.classList.contains('open');
      document.querySelectorAll('.crazxy-mobile-sub').forEach(function(s){ s.classList.remove('open'); });
      document.querySelectorAll('.crazxy-mobile-toggle').forEach(function(t){ t.classList.remove('open'); });
      if (!isOpen){ sub.classList.add('open'); toggle.classList.add('open'); }
    });
  });

  /* Promo banner height sync */
  function updatePromoHeight(){
    var banner = document.getElementById('crazxy-promo-banner');
    var h = (banner && banner.offsetHeight > 0) ? banner.offsetHeight : 44;
    document.documentElement.style.setProperty('--crazxy-promo-h', h+'px');
    var nav = document.getElementById('crazxy-navbar');
    var navH = nav ? nav.offsetHeight : 72;
    document.documentElement.style.setProperty('--crazxy-nav-offset', (h+navH)+'px');
    var dr = document.getElementById('crazxy-mobile-drawer');
    if(dr) dr.style.top = (h+navH)+'px';
  }
  updatePromoHeight();
  requestAnimationFrame(function(){ requestAnimationFrame(updatePromoHeight); });
  setTimeout(updatePromoHeight, 200);

  /* Debounced resize — ignore browser chrome show/hide during scroll on mobile */
  var resizeTimer = null;
  var isScrolling = false;
  window.addEventListener('scroll', function() {
    isScrolling = true;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() { isScrolling = false; }, 200);
  }, { passive: true });
  window.addEventListener('resize', function() {
    /* Only update if not caused by mobile browser chrome appearing/disappearing */
    if (!isScrolling) updatePromoHeight();
  });

  var promoClose = document.getElementById('crazxy-promo-close');
  if(promoClose) promoClose.addEventListener('click', function(){ setTimeout(updatePromoHeight, 50); });

  /* ── Currency picker toggle ── */
  (function() {
    var btn    = document.getElementById('czx-cur-btn');
    var drop   = document.getElementById('czx-cur-drop');
    var search = document.getElementById('czx-cur-search');
    var noRes  = document.getElementById('czx-cur-no-results');

    if (search) {
      search.addEventListener('input', function() {
        var q = search.value.trim().toLowerCase();
        var opts = drop.querySelectorAll('.czx-cur-opt');
        var visible = 0;
        opts.forEach(function(opt) {
          var show = !q || opt.textContent.toLowerCase().indexOf(q) !== -1;
          opt.style.display = show ? '' : 'none';
          if (show) visible++;
        });
        if (noRes) noRes.style.display = visible === 0 ? 'block' : 'none';
      });
      btn.addEventListener('click', function() {
        setTimeout(function() {
          if (drop.classList.contains('open')) {
            search.focus();
          } else {
            search.value = '';
            drop.querySelectorAll('.czx-cur-opt').forEach(function(o) { o.style.display = ''; });
            if (noRes) noRes.style.display = 'none';
          }
        }, 50);
      });
    }
    if (!btn || !drop) return;
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var open = drop.classList.toggle('open');
      btn.classList.toggle('open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.czx-cur-wrap')) {
        drop.classList.remove('open');
        btn.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        drop.classList.remove('open');
        btn.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  })();
})(); /* end main navbar IIFE */

// ── Search overlay: type → instant preview from cached product list → navigate to all-products ──
(function() {
  var overlay     = document.getElementById('czx-search-overlay');
  var input       = document.getElementById('czx-search-input');
  var resultsList = document.getElementById('czx-search-results-list');
  var goBtn       = document.getElementById('czx-search-go');

  if (!overlay || !input) return;

  /* ── Cached product list fetched once from all-products page ── */
  var productCache = null;
  var cacheLoading = false;

  function loadProductCache() {
    if (productCache || cacheLoading) return;
    cacheLoading = true;
    fetch('/pages/all-product', { headers: { 'Accept': 'text/html' } })
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('.czx-card[data-title][data-url]');
        productCache = Array.from(cards).map(function(c) {
          return {
            title: c.dataset.title || '',
            url:   c.dataset.url   || '',
            price: c.dataset.price || '',
            img:   (c.querySelector('.czx-card__img') || {}).src || ''
          };
        });
        cacheLoading = false;
      })
      .catch(function() { cacheLoading = false; });
  }

  function openOverlay() {
    overlay.classList.add('open');
    setTimeout(function() { input.focus(); }, 60);
    loadProductCache(); /* pre-fetch while user is typing */
  }
  function closeOverlay() {
    overlay.classList.remove('open');
    input.value = '';
    if (resultsList) resultsList.innerHTML = '';
  }

  document.querySelectorAll('.czx-search-trigger').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation();
      openOverlay();
    });
  });

  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeOverlay();
  });

  function doNavigate() {
    var q = input.value.trim();
    if (q) window.location.href = '/pages/all-product?q=' + encodeURIComponent(q);
  }
  if (goBtn) goBtn.addEventListener('click', doNavigate);

  function fmt(cents) {
    return (parseInt(cents, 10) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  function renderResults(q) {
    if (!resultsList) return;
    if (!productCache) {
      /* Cache not ready yet — show a search link */
      resultsList.innerHTML = '<div class="czx-sr-footer"><a href="/pages/all-product?q=' + encodeURIComponent(q) + '">Search "' + q + '" in All Products →</a></div>';
      return;
    }
    var ql = q.toLowerCase();
    var matched = productCache.filter(function(p) {
      return p.title.toLowerCase().includes(ql);
    });

    /* Sort: title starts with query first, then word starts with query, then contains */
    matched.sort(function(a, b) {
      var ta = a.title.toLowerCase();
      var tb = b.title.toLowerCase();
      function rank(t) {
        if (t.startsWith(ql)) return 0;
        if (t.split(' ').some(function(w){ return w.startsWith(ql); })) return 1;
        return 2;
      }
      var ra = rank(ta), rb = rank(tb);
      if (ra !== rb) return ra - rb;
      return ta.localeCompare(tb);
    });

    if (!matched.length) {
      resultsList.innerHTML = '<div class="czx-sr-empty">No results for "<strong>' + q + '</strong>"</div>'
        + '<div class="czx-sr-footer"><a href="/pages/all-product?q=' + encodeURIComponent(q) + '">Search all products →</a></div>';
      return;
    }
    var html = '';
    matched.slice(0, 8).forEach(function(p) {
      html += '<a class="czx-sr-item" href="' + p.url + '">';
      if (p.img) html += '<img class="czx-sr-img" src="' + p.img + '" alt="" loading="lazy">';
      html += '<div><div class="czx-sr-title">' + p.title + '</div>';
      if (p.price) html += '<div class="czx-sr-price">' + fmt(p.price) + '</div>';
      html += '</div></a>';
    });
    if (matched.length > 8) {
      html += '<div class="czx-sr-footer"><a href="/pages/all-product?q=' + encodeURIComponent(q) + '">See all ' + matched.length + ' results →</a></div>';
    }
    resultsList.innerHTML = html;
  }

  var debounceTimer = null;
  input.addEventListener('input', function() {
    var q = this.value.trim();
    clearTimeout(debounceTimer);
    if (!q) { if (resultsList) resultsList.innerHTML = ''; return; }
    debounceTimer = setTimeout(function() { renderResults(q); }, 150);
  });

  input.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') doNavigate();
    if (e.key === 'Escape') closeOverlay();
  });
})();

// ── Live cart counter — updates immediately on add-to-cart ──
(function() {
  function czxUpdateCartBadge(count) {
    ['czx-cart-count-desktop', 'czx-cart-count-mobile', 'czx-cart-count-drawer'].forEach(function(id) {
      var el = document.getElementById(id);
      if (count > 0) {
        if (el) {
          el.textContent = count;
        } else {
          document.querySelectorAll('a[aria-label="Cart"]').forEach(function(link) {
            var badge = document.createElement('span');
            badge.id = id;
            badge.textContent = count;
            badge.style.cssText = 'position:absolute;top:2px;right:2px;min-width:16px;height:16px;background:#FF006E;color:#fff;font-family:\'Boogaloo\',cursive;font-size:10px;border-radius:999px;display:flex;align-items:center;justify-content:center;padding:0 3px;line-height:1;';
            link.style.position = 'relative';
            link.appendChild(badge);
          });
        }
      } else {
        if (el) el.remove();
      }
    });
  }

  function czxRefreshBadge() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { czxUpdateCartBadge(cart.item_count); })
      .catch(function() {});
  }

  // Intercept /cart/add.js fetch calls for immediate update
  var _origFetch = window.fetch;
  window.fetch = function(url, opts) {
    var result = _origFetch.apply(this, arguments);
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
      result.then(function(res) {
        if (res.ok) czxRefreshBadge();
        return res;
      }).catch(function() {});
    }
    return result;
  };

  // Also listen for cart:refresh event as fallback
  document.addEventListener('cart:refresh', czxRefreshBadge);
  document.addEventListener('shopify:section:load', czxRefreshBadge);
  // ── Auto-detect country on first visit and switch currency ──
  // PERFORMANCE: Deferred 2.5s after page load so it never blocks rendering or LCP.
  setTimeout(function() {
    if (localStorage.getItem('czx-cur-detected')) return; // only once
    var currentCountry = (document.getElementById('crazxy-navbar') || document.body).dataset.country || '';
    // country code injected via data-country attribute on #crazxy-navbar
    fetch('https://ipapi.co/json/')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var detected = (data.country_code || '').toUpperCase();
        if (!detected || detected === currentCountry) {
          localStorage.setItem('czx-cur-detected', '1');
          return;
        }
        // Check if detected country is in our available list
        var available = JSON.parse((document.getElementById('crazxy-navbar')||{}).dataset.countries||'[]');
        if (available.indexOf(detected) === -1) {
          localStorage.setItem('czx-cur-detected', '1');
          return;
        }
        localStorage.setItem('czx-cur-detected', '1');
        // Submit the localization form with detected country
        var form = document.getElementById('czx-cur-form') || document.getElementById('czx-mob-cur-form');
        if (!form) return;
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'country_code';
        input.value = detected;
        form.appendChild(input);
        form.submit();
      })
      .catch(function() { localStorage.setItem('czx-cur-detected', '1'); });
  }, 2500); // deferred — must not block LCP

  // Mobile currency selector toggle + search
  var mobCurToggle = document.getElementById('czx-mob-cur-toggle');
  var mobCurSub    = document.getElementById('czx-mob-cur-sub');
  var mobCurSearch = document.getElementById('czx-mob-cur-search');
  var mobCurNoRes  = document.getElementById('czx-mob-cur-no-results');

  if (mobCurToggle && mobCurSub) {
    mobCurToggle.addEventListener('click', function() {
      var isOpen = mobCurSub.classList.toggle('open');
      mobCurToggle.classList.toggle('open', isOpen);
      if (isOpen && mobCurSearch) setTimeout(function() { mobCurSearch.focus(); }, 50);
    });
  }

  if (mobCurSearch) {
    mobCurSearch.addEventListener('input', function() {
      var q = mobCurSearch.value.trim().toLowerCase();
      var opts = mobCurSub.querySelectorAll('.czx-mob-cur-opt');
      var visible = 0;
      opts.forEach(function(opt) {
        var show = !q || opt.textContent.toLowerCase().indexOf(q) !== -1;
        opt.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      if (mobCurNoRes) mobCurNoRes.style.display = visible === 0 ? 'block' : 'none';
    });
  }

})();
